import { useCallback, useState } from 'react'

type UseSetActions<T> = {
  add: (item: T) => void
  delete: (item: T) => void
  clear: () => void
  replace: (items: Iterable<T> | ReadonlyArray<T> | null) => void
}

type UseSetReturn<T> = [Set<T>, UseSetActions<T>]

export function useSet<T>(initial?: Iterable<T> | ReadonlyArray<T> | null): UseSetReturn<T> {
  const [set, setSet] = useState(new Set<T>(initial))

  const actions: UseSetActions<T> = {
    add: useCallback((item: T) => {
      setSet((prev) => {
        const copy = new Set(prev)
        copy.add(item)
        return copy
      })
    }, []),
    delete: useCallback((item: T) => {
      setSet((prev) => {
        const copy = new Set(prev)
        copy.delete(item)
        return copy
      })
    }, []),
    clear: useCallback(() => {
      setSet(new Set())
    }, []),
    replace: useCallback((items: Iterable<T> | ReadonlyArray<T> | null) => {
      setSet(new Set(items))
    }, []),
  }

  return [set, actions]
}
